import React, { createContext, useContext, useState, ReactNode } from 'react';

interface IHomeBottomBarContext {
  isRaisedHandsOpen: boolean;
  openRaisedHands: () => void;
  closeRaisedHands: () => void;
}

const HomeBottomBarContext = createContext<IHomeBottomBarContext | null>(null);

export const useHomeBottomBarContext = () => {
  const context = useContext(HomeBottomBarContext);
  if (!context) {
    throw new Error(
      'useHomeBottomBar must be used within HomeBottomBarProvider',
    );
  }
  return context;
};

export const HomeBottomBarProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isRaisedHandsOpen, setIsRaisedHandsOpen] = useState(false);

  const openRaisedHands = () => {
    setIsRaisedHandsOpen(true);
  };

  const closeRaisedHands = () => {
    setIsRaisedHandsOpen(false);
  };

  return (
    <HomeBottomBarContext.Provider
      value={{
        isRaisedHandsOpen,
        openRaisedHands,
        closeRaisedHands,
      }}
    >
      {children}
    </HomeBottomBarContext.Provider>
  );
};

export default HomeBottomBarProvider;
